export default function useUser() {
  const pb = useNuxtApp().$pb
  const user = ref()

  pb.authStore.onChange(() => {
    user.value = pb.authStore.record
  }, true)

  function logout() {
    pb.authStore.clear()
    user.value = undefined
    navigateTo('/')
  }

  function isUsers(id: string, collection: string) {
    if (!id || !collection)
      return false
    return user.value?.[collection]?.some(b => b === id)
  }

  const admin = computed(() => user.value?.role === 'admin')

  async function getBusinesses(): Promise<Business[] | []> {
    if (admin.value) {
      const businesses = await pb.collection<Business>('businesses').getFullList({ sort: 'name' }).catch(() => [])
      return businesses
    }
    const userB = await pb.collection('users').getOne<User>(user.value?.id, { expand: 'businesses', fields: 'expand.businesses.name, expand.businesses.id, expand.businesses.verified, expand.businesses.hidden, expand.businesses.liveUntil' }).catch(() => undefined)
    if (!userB?.expand?.businesses)
      return []
    return userB?.expand?.businesses.map((x) => {
      let disabled = false
      if (!x.verified || x.hidden || !x.liveUntil)
        disabled = true
      if (x.liveUntil && new Date(x.liveUntil) < new Date())
        disabled = true
      return { ...x, disabled }
    })
  }

  return {
    user: computed(() => user.value),
    userId: computed(() => user.value?.id),
    isUsers,
    logout,
    getBusinesses,
    loggedIn: computed(() => user.value?.id),
    admin,
    role: computed(() => user.value?.role),
  }
}
